module.exports = {
	isIdCreate: (id) => {
		return id === false;
	},
	parse: (response) => {
		let total = 0;
		let items = [];
		let itemsPerPage = 0;
		let page = 1;
		if (
			typeof (response['hydra:member']) !== 'undefined' &&
			typeof (response['hydra:totalItems']) !== 'undefined'
		) {
			items = response['hydra:member'];
			total = response['hydra:totalItems'];
		}
		if (
			typeof (response['hydra:itemsPerPage']) !== 'undefined'
		) {
			itemsPerPage = response['hydra:itemsPerPage'];
		}
		if (
			typeof (response['hydra:page']) !== 'undefined'
		) {
			page = response['hydra:page'];
		}

		return {
			total,
			items,
			itemsPerPage,
			page
		}
	},
	parseOnce: (response) => {
		if (
			typeof (response['hydra:member']) !== 'undefined' &&
			typeof (response['hydra:totalItems']) !== 'undefined' &&
			parseInt(response['hydra:totalItems'], 10) >= 1
		) {
			return response['hydra:member'][0];
		}
		return {}
	},
	parseId: (id) => {
		if (typeof id !== 'undefined') {
			let temp = id.split('/');
			return temp[temp.length - 1];
		}
		return false;
	}
}
